import * as React from 'react';
import Result from "./Result";
import { TestResults, VolumeUnit, DiffusingCapacityUnit, FlowUnit, PressureUnit, VolumetricParameter, FlowParameter, DiffusingCapacityParameter, PressureParameter } from './PFTAPITypes';
import { ParameterTypeName } from '../../misc/api/ParameterTypes';
export interface ParameterResultProps {
    results: Array<TestResults>;
    testNumber: number;
    testIndex: number;
    parameterId: ParameterTypeName;
    isRepeatability?: boolean;
    units: VolumeUnit | FlowUnit | DiffusingCapacityUnit | PressureUnit;
    isLoading?: boolean;
    isRejected?: boolean;
    automationSection?: string;
}
export default class ParameterResult extends React.PureComponent<ParameterResultProps> {
    render() {
        const IsRepeatabilityParameterType = (input: ParameterTypeName): boolean => {
            const repeatabilityParameters: ParameterTypeName[] = [
                ParameterTypeName.PARAM_FEV1, 
                ParameterTypeName.PARAM_FVC, 
                ParameterTypeName.PARAM_VC,
                ParameterTypeName.PARAM_VC_ABSOLUTE_REPEATABILITY,
                ParameterTypeName.PARAM_IC_REPEAT,
            ];
            return repeatabilityParameters.some(p => p === input);
        }
        const FetchParameter = (): VolumetricParameter | FlowParameter | DiffusingCapacityParameter | PressureParameter => {
            if (this.props.isRepeatability) {
                return this.props.results[this.props.testIndex].RepeatabilityParameters.find(x => x.ParameterType === this.props.parameterId
                    &&
                    (
                        /*      HACK: This extra FEV1 & FVC comparison is needed due to an upstream issue where the unit type is set incorrectly due to the different units needed for repeatability
                                See issue #4626 for more info, long term this should be handled better  */
                        IsRepeatabilityParameterType(x.ParameterType)
                        || x.Units === this.props.units
                    )
                );
            } else {
                return this.props.results[this.props.testIndex].TestParameters.find(x => x.ParameterType === this.props.parameterId && x.Units == this.props.units);
            }
        }
        const ConstructParameterResult = (): JSX.Element => {
            let parameter = FetchParameter();

            let section: string = (this.props.automationSection ? `${this.props.automationSection}-` : '');

            return (
                <td className={this.props.isRejected ? 'text-muted' : ''} data-automationid={`parameter-result-${section}${this.props.parameterId}-${this.props.testNumber}`}>
                    <Result parameter={parameter} isLoading={this.props.isLoading} />
                </td>
            );
        }
        return ConstructParameterResult();
    }
}
